const Search = (() => {

  const DOM = {};

  const cacheDOM = () => {
    DOM.container = document.getElementById('search');
    DOM.search = document.getElementById('search-button');
  };

  const eventListener = () => {
    DOM.search.addEventListener('click', (e) => {
      e.preventDefault();
      if(DOM.container.classList.contains('hidden')) {
        DOM.container.classList.remove('hidden');
      } else {
        DOM.container.classList.add('hidden');
      }
    });
  };

  const init = () => {
    cacheDOM();
    eventListener();

  };

  return {
    init

  }

})();

export default Search;
